var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-row',{attrs:{"no-gutters":""}},[_c('v-col',{attrs:{"cols":"12"}},[_c('div',{staticClass:"img-banner"},[_c('img',{attrs:{"src":require("@/assets/lol/karmine-banner.png"),"width":"100%","alt":""}}),_vm._t("details")],2)])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }